import { ref, computed } from "vue";
import { cockpitExplorerService } from "@/api";

const DEFAULT_RANGE_MS = 25 * 60 * 60 * 1000;

export const useExplorersStatistics = ({ rangeInMs = DEFAULT_RANGE_MS, isForProject = true, isForOthers = true } = {}) => {
  const isProjectStatistics = ref(isForProject);
  const isOthersStatistics = ref(isForOthers);

  const rangeMs = ref(rangeInMs);
  const staticToMs = ref(0);
  const _getToMs = () => {
    return staticToMs.value || Date.now();
  };
  const toMs = ref(_getToMs());
  const fromMs = computed(() => toMs.value - rangeMs.value);

  const setStaticToMs = (ms=0) => {
    staticToMs.value = ms;
  };
  const updateRangeMs = (ms=DEFAULT_RANGE_MS) => {
    rangeMs.value = ms;
  };

  const statisticsContextReqParam = computed(() => {
    const p = [];
    if (isProjectStatistics.value) {
      p.push("project");
    }
    if (isOthersStatistics.value) {
      p.push("other");
    }
    return p.join(",");
  });

  const isStatisticsLoading = ref(false);
  const isErrorStatisticsLoad = ref(false);
  const getExplorerTestsStatistic = async (id, { isSilent = false } = {}) => {
    if (!isSilent) {
      isStatisticsLoading.value = true;
    }

    toMs.value = _getToMs();
    const to = Math.trunc(toMs.value / 1000);
    const from = Math.trunc(fromMs.value / 1000);
    const context = statisticsContextReqParam.value;

    try {
      return await cockpitExplorerService.v1.getExplorerTestsStatistics({ id, to, from, context });
    } catch (err) {
      isErrorStatisticsLoad.value = true;
      throw err;
    } finally {
      isStatisticsLoading.value = false;
    }
  };

  return {
    isProjectStatistics,
    isOthersStatistics,
    rangeMs,
    fromMs,
    toMs,
    statisticsContextReqParam,
    isStatisticsLoading,
    isErrorStatisticsLoad,
    setStaticToMs,
    updateRangeMs,
    getExplorerTestsStatistic,
  }
};
